import script from "./archivedPotentials.vue?vue&type=script&setup=true&lang=ts"
export * from "./archivedPotentials.vue?vue&type=script&setup=true&lang=ts"

import "./archivedPotentials.vue?vue&type=style&index=0&id=691d6fe8&lang=scss"

const __exports__ = script;

export default __exports__